import './styles.scss'
import React from 'react'

/**
 *
 * @param {object} props
 * @param {Object} props.children
 * @param {string} [props.classname]
 * @param {object} [props.style]
 * @param {string} [props.title]
 * @param {string} [props.subtitle]
 */
function ContainerBox(props) {
  const {
    classname = '', style = {}, title, subtitle, children
  } = props

  return (
    <div
      className={`msgview-config-container ${classname}`}
      style={style}
    >
      <div className='msgview-config-container__content'>
        <div className='msgview-config-container__content-header'>
          {title && <h2>{title}</h2>}
          {subtitle && <h4>{subtitle}</h4>}
        </div>
        <div className='msgview-config-container__content-body'>
          {children}
        </div>
      </div>
    </div>
  )
}

export default ContainerBox
